<app-filter-panel [numberOfResults]="numberOfResults" [activeFilterCount]="activeFilterCount"
  (apply)="onApply()" (cancel)="onCancel()">

  <!-- Regions -->
  <div class="row g-0 m-0 borderb">
    <div class="col-md-12 d-flex justify-content-start custom-left-padding pt-3 pe-3 pb-3">
      <span class="item-name">{{ 'REGIONS' | translate }}</span>
    </div>
    <div class="col-md-12 d-flex flex-column justify-content-start custom-left-padding pe-3 pb-3">
      <div class="row-md-12 switch-container d-flex pb-3" *ngFor="let region of regions">
        <div class="col-auto d-flex align-items-center">
          <label class="switch" [for]="'checkbox-' + region.name">
            <input type="checkbox" [id]="'checkbox-' + region.name"
              [checked]="isIn(draftRegions, region.value!)"
              (change)="draftRegions = toggleGuid(draftRegions, region)" />
            <span class="slider round"></span>
          </label>
        </div>
        <div class="col ps-3 d-flex justify-content-start">
          <label [for]="'checkbox-' + region.name">{{ region.name }}</label>
        </div>
      </div>
    </div>
  </div>

  <!-- Limit Types -->
  <div class="row g-0 m-0 borderb">
    <div class="col-md-12 d-flex justify-content-start custom-left-padding pt-3 pe-3 pb-3">
      <span class="item-name">{{ 'LOADLIMITMANAGEMENT_LIMITTYPE' | translate }}</span>
    </div>
    <div class="col-md-12 d-flex flex-column justify-content-start custom-left-padding pe-3 pb-3">
      <div class="row-md-12 switch-container d-flex pb-3" *ngFor="let item of limitTypes">
        <div class="col-auto d-flex align-items-center">
          <label class="switch" [for]="'checkbox-' + item">
            <input type="checkbox" [id]="'checkbox-' + item"
              [checked]="isIn(draftLimitTypes, item)"
              (change)="draftLimitTypes = toggle(draftLimitTypes, item)" />
            <span class="slider round"></span>
          </label>
        </div>
        <div class="col ps-3 d-flex justify-content-start">
          <label [for]="'checkbox-' + item">{{ item }}</label>
        </div>
      </div>
    </div>
  </div>

</app-filter-panel>
